import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type {
  IOfficeConsentContentApi,
  IOfficeConsentContentApiResponse,
} from '../types/OfficeConsentContent.api';
import type { IGetPublicConsentParameters } from '../types/PublicConsent.parameters';

export const getPublicConsent = async (
  params: IGetPublicConsentParameters,
): Promise<IOfficeConsentContentApi> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IOfficeConsentContentApiResponse>(
    `/credential-service/consents/${params.consent}`,
    {
      headers,
    },
  );

  return response.data.data;
};
